// Plain JavaScript version of your Stimulus controller

// Constants
const CONTROLLER = "data-header-target";
const HEADER_CONTENT = "header"; // #header
const TARGET_FIRST_LEVEL_MENU_DROPDOWN = "first-level-menu-dropdown"; // .tvsu-header__menu-link.tvsu-arrow-down
const TARGET_LANG = "lang"; // .tvsu-header__lang
// const TARGET_LANG_DROPDOWN = "lang-dropdown"; // .tvsu-header__lang
const TARGET_MENU_CONTENT = "menu-content"; // href.tvsu-dropdown-menu
const TARGET_SECOND_LEVEL_MENU_DROPDOWN = "second-level-menu-dropdown"; // .tvsu-dropdown-menu__text
const HEADER_TARGETS = [
  "short-logo",
  "full-logo",
  "title",
  "menu-block",
  "student-cabinet",
  "lang",
  "phone",
  "mburger"
];
const HEADER_SIZES_PROPS = [
  ["mburger"],
  ["menu-block"],
  ["menu-block", "phone"],
  ["menu-block", "phone", "title", "student-cabinet"],
]

const getElement = (name, parent = document) => {
  return parent.querySelector(`[${CONTROLLER}~="${name}"]`);
};

const getElements = (name, parent = document) => {
  return Array.from(parent.querySelectorAll(`[${CONTROLLER}~="${name}"]`));
};

const throttle = (fn) => {
  let ticking = false;
  return () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        fn();
        ticking = false;
      });
      ticking = true;
    }
  };
};

export class Header {
  constructor() {
    if (this.connectTargets()) {
      this.connect();
    }
  }

  destroy() {
    this.unbindActions();
  }

  connectTargets() {
    this.element = getElement(HEADER_CONTENT);
    if (!this.element) {
      return false;
    }

    this.firstLevelMenuDropdownTargets = getElements(
      TARGET_FIRST_LEVEL_MENU_DROPDOWN,
      this.element,
    );
    this.secondLevelMenuDropdownTargets = getElements(
      TARGET_SECOND_LEVEL_MENU_DROPDOWN,
      this.element,
    );
    this.langTarget = getElement(TARGET_LANG, this.element);
    // this.langDropdownTarget = getElement(TARGET_LANG_DROPDOWN, this.element);
    this.menusContentTargets = getElements(TARGET_MENU_CONTENT, this.element);

    return true;
  }

  connect() {
    this._showMenu = this.showMenu.bind(this);
    this._showSecondLevelMenu = this.showSecondLevelMenu.bind(this);
    this._showLangMenu = this.showLangMenu.bind(this);
    // this._updateHeaderBackground = this.updateHeaderBackground.bind(this);
    this._onScroll = throttle(this.updateHeaderBackground.bind(this));
    this._headerLeave = this.headerLeave.bind(this);

    this.updateHeaderBackground();
    this.bindActions();
    this.resize = new HeaderResize();
    // this.element.classList.remove("tvsu-header__init");
  }

  bindActions() {
    this.firstLevelMenuDropdownTargets.forEach((link) => {
      link.addEventListener("click", this._showMenu);
    });
    this.secondLevelMenuDropdownTargets.forEach((link) => {
      link.addEventListener("click", this._showSecondLevelMenu);
    });
    this.langTarget?.addEventListener("click", this._showLangMenu);
    window.addEventListener("scroll", this._onScroll);
    document.addEventListener("click", this._headerLeave);
  }

  unbindActions() {
    this.langTarget?.removeEventListener("click", this._showLangMenu);
    this.firstLevelMenuDropdownTargets.forEach((link) => {
      link.removeEventListener("click", this._showMenu);
    });
    this.secondLevelMenuDropdownTargets.forEach((link) => {
      link.removeEventListener("click", this._showSecondLevelMenu);
    });
    window.removeEventListener("scroll", this._onScroll);
    document.removeEventListener("click", this._headerLeave);
  }

  getCurrentFirstLevelMenuTarget(event) {
    const target = event.target;
    return target.classList.contains("tvsu-arrow-down") ? target : target.parentElement;
  }

  showMenu(event) {
    // event.preventDefault();
    const target = this.getCurrentFirstLevelMenuTarget(event);
    if (!target) {
      return;
    }
    this._setInactiveFirstLevelMenuItems();
    target.classList.add("tvsu-active");
    this.element.classList.add("tvsu-header__menu_opened");

    if (this.element.dataset.isFaculty === "true") {
      return;
    }

    this.menusContentTargets.forEach((el) => el.classList.add("d-none"));
    const activeMenu = this.menusContentTargets.find(
      (el) => el.dataset.menuId === target.dataset.menuId,
    );
    activeMenu?.classList.remove("d-none");
  }

  showSecondLevelMenu(event) {
    const target = event.target;
    const list = target.parentNode?.querySelector(
      '[data-header-target="second-level-menu-content"]',
    );
    if (list) {
      target.classList.toggle("tvsu-with-arrow-down");
      target.classList.toggle("tvsu-with-arrow-right");
      list.classList.toggle("d-none");
    }
  }

  showLangMenu(event) {
    // event.preventDefault();
    this.langTarget?.classList.toggle("tvsu-active");
    // this.langDropdownTarget?.classList.toggle("tvsu-active");
  }

  updateHeaderBackground() {
    if (window.pageYOffset > 20 && document.body.clientWidth > 1109) {
      this.element.classList.add("tvsu-header-background");
    } else {
      this.element.classList.remove("tvsu-header-background");
    }
  }

  headerLeave(event) {
    let targetEl = event.target;
    do {
      if (targetEl === this.element) {
        return;
      }
      targetEl = targetEl.parentNode;
    } while (targetEl);

    this._hideAll();
  }

  _hideAll() {
    this.element.classList.remove("tvsu-header__menu_opened");
    this._setInactiveFirstLevelMenuItems();
    this.langTarget?.classList.remove("tvsu-active");
    // this.langDropdownTarget?.classList.remove("tvsu-active");
  }

  _setInactiveFirstLevelMenuItems() {
    this.firstLevelMenuDropdownTargets.forEach((link) => {
      link.classList.remove("tvsu-active");
    });
  }
}


export class HeaderResize {
  constructor() {
    if (this.connectTargets()) {
      this.connect();
    }
  }

  destroy() {
    this.unbindActions();
  }

  connectTargets() {
    this.element = getElement(HEADER_CONTENT);
    if (!this.element) {
      return false;
    }

    this.mobileTitleTarget = getElement("mobile-title", this.element);
    return true;
  }

  connect() {
    this._mobileHeaderTitle = this.mobileHeaderTitle.bind(this);

    this.elementsWithWidth = this.getElementsWithWidth(this.element);
    this.widthProps = this.getWidthProps(this.elementsWithWidth);

    this.bindActions();
    this.mobileHeaderTitle();
    this.element.classList.remove("tvsu-header__init");
  }

  bindActions() {
    window.addEventListener('resize', this._mobileHeaderTitle)
  }

  unbindActions() {
    window.removeEventListener('resize', this._mobileHeaderTitle)
  }

  getElementsWithWidth(parent) {
    const _localGetElementWidth = (el) => {
      if (!el) {
        return 0;
      }
      // Получаем размеры border-box (content + padding + border)
      const rect = el.getBoundingClientRect();
      const baseWidth = rect.width;

      // Получаем computed-стили для margin
      const style = getComputedStyle(el);
      const marginLeft = parseFloat(style.marginLeft) || 0;
      const marginRight = parseFloat(style.marginRight) || 0;

      // Складываем всё вместе
      return baseWidth + marginLeft + marginRight;
    }

    return HEADER_TARGETS.reduce((hash, name) => {
      const el = getElement(name, parent);
      hash[name] = { el: el, width: _localGetElementWidth(el) }
      return hash;
    }, {});
  }

  getWidthProps(elementsWithWidth) {
    const _localCalcProps = (keys) => {
      const enabled = HEADER_TARGETS.filter(name => !keys.includes(name))
      return {
        disabled: keys,
        enabled,
        size: enabled.reduce((acc, name) => acc + elementsWithWidth[name].width, 0)
      }
    }
    const _localGetProps = (disabledLogo) => {
      return HEADER_SIZES_PROPS.map(keys => _localCalcProps([...keys, disabledLogo]))
    }

    const fullLogoProps = _localGetProps('short-logo');
    const shortLogoProps = _localGetProps('full-logo');
    const widthProps = [];
    for (let i = 0; i < fullLogoProps.length; i++) {
      widthProps.push(fullLogoProps[i], shortLogoProps[i]);
    }
    return widthProps;
  }

  mobileHeaderTitle() {
    const pageWidth = Math.min(1920, document.body.clientWidth) - 30;

    for (const props of this.widthProps) {
      if (props.size <= pageWidth) {
        this.applyProps(props)
        break;
      }
    }
  }

  applyProps(props) {
    props.disabled.forEach(el => {
      this.elementsWithWidth[el]?.el?.classList.add('d-none');
    });
    props.enabled.forEach(el => {
      this.elementsWithWidth[el]?.el?.classList.remove('d-none');
    });
    const action = props.disabled.includes('title') ? 'remove' : 'add';
    this.mobileTitleTarget?.classList[action]('d-none');
  }
}